<template>
  <div>
    <div class="back-button" v-if="backButtonEnabled" style="display: none">
      <div
        class="nav-back"
        :class="{ 'is-hidden': !showHeader }"
        @click="navBack()"
      >
        <md-icon class="md-size-3x nav-back-icon">arrow_left</md-icon>
      </div>
    </div>
    <div
      class="public-brand"
      :class="{
        'no-logo': !logo && !fullSize,
        'no-image': !image,
        'image-not-stretched': imageNotStretched,
      }"
    >
      <div
        v-if="image"
        class="public-brand-img"
        :style="{
          'background-image': !image
            ? 'none'
            : `url(${mixinGetFilePath(
                image,
                imageExtension === 'gif' || missingThumbnails ? 'O' : 'XL',
              )})`,
        }"
      ></div>
      <img
        v-if="logo && !imageNotStretched"
        :src="
          mixinGetFilePath(
            logo,
            logoExtension === 'gif' || missingThumbnails ? 'O' : 'XL',
          )
        "
        @error="handleMissingThumbnails"
        class="public-brand-logo"
      />
    </div>

    <md-card
      v-if="showCard"
      class="md-card-unspaced public-card rfider-shadow"
      :class="{ 'no-avatar': !avatar, 'no-logo-no-avatar': !logo && !avatar }"
    >
      <md-card-content>
        <div class="notranslate public-card-avatar-icon" v-if="avatar">
          <img
            :src="
              mixinGetFilePath(
                avatar,
                avatarExtension === 'gif' || missingThumbnails ? 'O' : 'M',
              )
            "
            alt="product brand"
            class="public-card-avatar"
          />
        </div>
        <div class="notranslate public-card-name public-basic-info-name">
          <template v-if="friendlyName">{{ friendlyName }} </template><br />
          {{ name }}
          <div v-if="itemId" class="public-card-item">{{ itemId }}</div>
        </div>
        <div class="public-card-short-description" v-if="shortDescription">
          <div class="ql-snow">
            <div class="ql-editor" v-html="shortDescription"></div>
          </div>
        </div>
        <div v-if="allowClose" class="public-card-close">
          <p class="h4">
            {{ $t('shared.service_sent') }}<br />
            <md-button class="md-primary md-raised" @click="closeWindow">{{
              $t('shared.close_window')
            }}</md-button>
          </p>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import settings from '@/settings';

export default {
  data() {
    return {
      settings: settings,
      missingThumbnails: false,
      showHeader: true,
    };
  },
  props: {
    name: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
    logo: {
      type: String,
      required: false,
    },
    avatar: {
      type: String,
      required: false,
    },
    shortDescription: {
      type: String,
      required: false,
    },
    itemId: {
      type: String,
    },
    friendlyName: {
      type: String,
    },
    allowClose: {
      type: Boolean,
    },
    fullSize: {
      type: Boolean,
    },
    showCard: {
      type: Boolean,
      default: true,
    },
    imageNotStretched: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    imageExtension() {
      try {
        return this.image.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return null;
      }
    },
    logoExtension() {
      try {
        return this.logo.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return null;
      }
    },
    avatarExtension() {
      try {
        return this.avatar.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return null;
      }
    },
    backButtonEnabled() {
      return !!this.$route.query.back;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    closeWindow() {
      window.close();
    },
    handleMissingThumbnails() {
      this.missingThumbnails = true;
    },

    navBack() {
      window.history.go(-1);
      return false;
    },
    onScroll() {
      if (window.pageYOffset < 0) {
        return;
      }
      this.showHeader = window.pageYOffset < 150;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-brand.scss';
</style>
